import protoRoot from "../proto-root";

function create({ cameraId, cameraName }) {
  const CameraInfo = protoRoot.lookupType("comm.CameraInfo");

  const CameraFacing = CameraInfo.lookupEnum("CameraFacing");

  return CameraInfo.create({
    cameraId,
    cameraFacing: CameraFacing.values.EXTERNAL,
    name: cameraName
  });
}

export default {
  create
};
// message CameraInfo {
//     string cameraId = 1;
//     CameraFacing cameraFacing = 2;
//     float zoomLevel = 3;
//     bool flashlightAvailable = 4;
//     bool flashlightAdjustable = 5;
//     string name = 6;
// }
